import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData,
  type RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError,
  type RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse,
  renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch,
} from '../../generated';

export type RenameCollectionMutationVariables =
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData['path'] &
    RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData['body'];

export type RenameCollectionMutation =
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse;

export const useRenameCollectionMutation = <
  TError = RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<RenameCollectionMutation, TError, RenameCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<RenameCollectionMutation, TError, RenameCollectionMutationVariables, TContext>({
    mutationKey: ['RenameCollection'],
    mutationFn: async ({ portfolio_id, collection_id, name }: RenameCollectionMutationVariables) => {
      const { data } = await renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch({
        path: { portfolio_id, collection_id },
        body: { name },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useRenameCollectionMutation.fetcher = (
  { portfolio_id, collection_id, name }: RenameCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch({
      path: { portfolio_id, collection_id },
      body: { name },
      throwOnError: true,
    });
    return data;
  };
};
